import {Component, ContentChild, Input, TemplateRef} from "@angular/core";
import {UtilsService} from "../../../../services/utils.service";

@Component({
  selector: "admin-table-collapsable",
  templateUrl: "./collapsable.component.html",
  styleUrls: ["./collapsable.component.css"]
})
export class TableCollapsableComponent<T = any> {

  @Input() items: T[] = [];
  @Input() custom: string[] = ["standard-table"];
  @Input() colspan: string = "8";

  @ContentChild("header", { static: true }) headerTemplate!: TemplateRef<any>;
  @ContentChild("first", { static: true }) firstTemplate!: TemplateRef<any>;
  @ContentChild("second", { static: true }) secondTemplate!: TemplateRef<any>;

  refid: string;

  constructor(
  ) {
    this.refid = UtilsService.generateRandomString()
  }

}
